import React from 'react'
import {NavLink} from 'react-router-dom';
import Logo from '../images/logo.PNG';
function Navbar() {
    return (
        <>
        
        <nav class="navbar navbar-expand-lg  sticky-top navbar-dark bg-dark">
  <div class="container-fluid">
    <NavLink to="/" ><img style={{width:"60px",}}src={Logo} alt="Not found"></img></NavLink>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
            <NavLink className="nav-link" to="/home" activeStyle={{fontWeight: "bold"}}>Home</NavLink>
        </li>
        <li class="nav-item">
            <NavLink className="nav-link" to="/register" activeStyle={{fontWeight: "bold"}}>RegisterAsset</NavLink>
        </li>
        <li class="nav-item">
            <NavLink className="nav-link" to="/show"activeStyle={{fontWeight: "bold"}} >ShowAsset</NavLink>
        </li>
        <li class="nav-item">
            <NavLink className="nav-link" to="/change" activeStyle={{fontWeight: "bold"}} >ChangeDetails</NavLink>
        </li>
        <li class="nav-item">
            <NavLink className="nav-link" to="/transfer" activeStyle={{fontWeight: "bold"}} >TransferAsset</NavLink>
        </li>
      </ul>
    </div>
  </div>
</nav>
        </>
    )
}

export default Navbar


// {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
//             <div className="container-fluid">
//                 <NavLink to="/" ><img style={{width:"60px",}}src={Logo} alt="Not found"></img></NavLink>
//                 <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
//                 <span className="navbar-toggler-icon"></span>
//                 </button>
//                 {/* <div className="collapse navbar-collapse" id="navbarNav">
//                 <ul class="navbar-nav">
//                     <li class="nav-item">
//                     <NavLink className="nav-link" to="/home" activeStyle={{fontWeight: "bold"}}>Home</NavLink>
//                     </li>
//                     <li class="nav-item">
//                     <NavLink className="nav-link" to="/register" activeStyle={{fontWeight: "bold"}}>RegisterAsset</NavLink>
//                     </li>
//                     <li class="nav-item">
//                     <NavLink className="nav-link" to="/show"activeStyle={{fontWeight: "bold"}} >ShowAsset</NavLink>
//                     </li>
//                     <li class="nav-item">
//                     <NavLink className="nav-link" to="/change" activeStyle={{fontWeight: "bold"}} >ChangeDetails</NavLink>
//                     </li>
//                     <li class="nav-item">
//                     <NavLink className="nav-link" to="/transfer" activeStyle={{fontWeight: "bold"}} >TransferAsset</NavLink>
//                     </li>
//                 </ul>
//                 </div> */}
//                 <div class="collapse navbar-collapse" id="navbarNav">
//                 <ul class="navbar-nav">
//                     <li class="nav-item">
//                     <a class="nav-link active" aria-current="page" href="#">Home</a>
//                     </li>
//                     <li class="nav-item">
//                     <a class="nav-link" href="#">Features</a>
//                     </li>
//                     <li class="nav-item">
//                     <a class="nav-link" href="#">Pricing</a>
//                     </li>
//                     <li class="nav-item">
//                     <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
//                     </li>
//                 </ul>
//                 </div>
//         </div>
//     </nav>     */}